import OploggMessages, {
  OploggList,
} from "features/TodoOploggSidebar/Oplogg/OploggMessages";
import { OploggProvider } from "features/TodoOploggSidebar/Oplogg/useOplogg";
import styled, { css } from "styled-components";

const zoomIn = (amount: number) => css`
  transform: scale(${amount});
  transform-origin: 0 0;
  max-width: ${100 / amount}vw;
  max-height: ${100 / amount}vh;
  grid-column: 1 / -1;
`;

const OploggPageWrapper = styled.div<{ $scale: number }>`
  ${({ $scale }) => zoomIn($scale)}

  & ${OploggList} {
    height: calc(100% - 75px);
  }
`;

export const OploggPage = () => (
  <OploggProvider>
    <OploggPageWrapper $scale={2}>
      <OploggMessages showHeader readonly />
    </OploggPageWrapper>
  </OploggProvider>
);
